// 论坛评论管理

import http from '../utils/http'

//  评论列表
export function listForumCommentAPI(data, params) {
    return http.post('/forumComment/list', data, params)
}
// 评论回复列表
export function replylistForumCommentAPI(params) {
    return http.get('/forumComment/replylist', params)
}
// 查看原帖
export function previewForumCommentAPI(data) {
    return http.post('/forumComment/preview', data)
}
// 删除评论
export function deleteReplyForumCommentAPI(data) {
    return http.post('/forumComment/deleteReply', data)
}
// 单条审批
export function commentauditForumCommentAPI(data) {
    return http.post('/forumComment/commentaudit', data)
}
// 批量审批不通过
export function unpassForumCommentAPI(data) {
    return http.post('/forumComment/unpass', data)
}

// 批量审批通过
export function passForumCommentAPI(data) {
    return http.post('/forumComment/pass', data)
}

//评论回复
export function addCommentAPI(data) {
    return http.post('/forumComment/addComment', data)
}

//仅自己可见
export function privateCommentAPI(data) {
    return http.post('/forumComment/privateComment', data)
}

